<template>
  <form @submit.prevent="validateAndSavePage" method="post"
    class="bg-brand-cloud min-h-[calc(100dvh_-_var(--navbarHeight)_-_var(--wp-admin--admin-bar--height,0px))] flex flex-col justify-between">
    <div class="md:px-[55px] pb-32 max-w-[1280px] w-full mx-auto">


      <back :status="status" :page="currentPage === 3 ? 3 : currentPage === 4 ? 4 : 1" :hash="postHash" @updateCurrentPage="handleUpdateCurrentPage" v-if="status !== 'publish'"></back>

      <div class="pb-4 mb-4 border-b border-brand-light-gray">
        <h1 class="mb-3 hdg">{{ headerMessage }}</h1>
        <div class="flex items-center justify-between">
          <p class="paragraph-default">{{ subheaderMessage }}</p>
          <div class="flex items-center group" @click="updateShowDeleteFormConfirmationPopup" v-if="status === 'publish'">
            <svg class='mr-2 icon icon-bin group-hover:text-brand-indigo'><use xlink:href='#icon-bin'></use></svg>
            <input class="cursor-pointer text-brand-eggplant group-hover:text-brand-indigo" type="button" value="Delete Form"/>
          </div>
        </div>
      </div>
      <div v-if="errorMessage" class="mb-5 font-bold text-form-error">{{ errorMessageText }}</div>
      <!-- TABBED SECTION -->
      <div class="overflow-hidden border rounded-b-sm border-brand-light-gray">
        <div class="grid grid-cols-1 ">
          <div class="grid grid-cols-4" v-if="status === 'publish'">
            <input @click="togglePageView(2)" type="button" value="Edit Content"
            class="font-semibold border-r border-brand-light-gray"
              :class="currentPage === 2 ? 'h-[50px] px-5 py-3 bg-brand-indigo border-l text-white border-r border-[#cccccc] justify-center items-center gap-2.5 inline-flex' : 'h-[50px] px-5 py-3 bg-[#e6e6fe] text-brand-eggplant justify-center items-center gap-2.5 inline-flex'"
            >
            <input @click="togglePageView(1)" type="button" value="Form Fields"
            class="font-semibold border-r border-brand-light-gray"
              :class="currentPage === 1 ? 'h-[50px] px-5 py-3 bg-brand-indigo border-l font-semibold text-white border-r border-[#cccccc] justify-center items-center gap-2.5 inline-flex' : 'h-[50px] px-5 py-3 bg-[#e6e6fe] justify-center items-center gap-2.5 inline-flex'"
              >
            <input @click="togglePageView(31)" type="button" value="Edit Colors"
            class="hidden font-semibold border-r border-brand-light-gray"
              :class="currentPage === 31 ? 'h-[50px] px-5 py-3 bg-brand-indigo border-l text-white border-r border-[#cccccc] justify-center items-center gap-2.5 inline-flex' : 'h-[50px] px-5 py-3 bg-[#e6e6fe] text-brand-eggplant justify-center items-center gap-2.5 inline-flex'"
            >
            <input @click="togglePageView(3)" type="button" value="Edit Confirmation"
            class="font-semibold"
              :class="currentPage === 3 ? 'h-[50px] px-5 py-3 bg-brand-indigo border-l text-white border-r border-[#cccccc] justify-center items-center gap-2.5 inline-flex' : 'h-[50px] px-5 py-3 bg-[#e6e6fe] text-brand-eggplant justify-center items-center gap-2.5 inline-flex'"
            >
            <input @click="togglePageView(4)" type="button" value="Edit Email"
            class="font-semibold border-l border-brand-light-gray"
              :class="currentPage === 4 ? 'h-[50px] px-5 py-3 bg-brand-indigo border-l text-white border-r border-[#cccccc] justify-center items-center gap-2.5 inline-flex' : 'h-[50px] px-5 py-3 bg-[#e6e6fe] text-brand-eggplant justify-center items-center gap-2.5 inline-flex'"
            >
          </div>

          <Transition name="tab-fade" mode="out-in">
          <div :key="currentPage">
          <div class="bg-white form-settings__edit-form-fields" v-if="currentPage === 1 && status === 'publish'">
            <div class="grid grid-cols-1 px-10 py-8 md:gap-20">
              <form-fields :sections="reactiveSections" :postId="postId" :userId="userId" :status="status" @updateLoading="handleLoadingUpdate" @updateSections="handleSectionsUpdate"></form-fields>
            </div>
          </div>
          <div class="bg-white form-settings__edit-content" v-if="currentPage === 2 || (status !== 'publish' && currentPage !== 3 && currentPage !== 4)">
            <div class="grid grid-cols-1 px-10 py-8 md:gap-20 md:grid-cols-2">
              <div class="flex flex-col">
                <input type="hidden" name="intake-form-post-id" id="intake-form-post-id" value="<?= get_the_ID() ?>">

                <label for="intake-form-title">Intake Form Title<span class="required">*</span></label>
                <input :class="{ 'border border-form-error': errorTitle, 'test': !errorTitle }"
                  v-model="form.content.title" type="text" name="intake-form-title" id="intake-form-title">

                <label for="intake-form-practice-name">Practice Name<span class="required">*</span></label>
                <input :class="{ 'border border-form-error': errorPractice, 'test': !errorPractice }"
                  v-model="form.content.name" type="text" name="intake-form-practice-name"
                  id="intake-form-practice-name">

                <label for="intake-form-image-caption">Image Caption</label>
                <input v-model="form.content.imageCaption" type="text" name="intake-form-image-caption"
                  id="intake-form-image-caption">

                <label for="intake-form-form-content">Intake Form Content<span class="required">*</span></label>
                <textarea :class="{ 'border border-form-error': errorContent, 'test': !errorContent }"
                  v-model="form.content.content" name="intake-form-form-content"
                  id="intake-form-form-content"><?= $form_data ? $form_data[0]['form_content'] : '' ?></textarea>

                <label for="intake-form-form-directions">General Form Directions<span class="required">*</span></label>
                <textarea :class="{ 'border border-form-error': errorDirections, 'test': !errorDirections }"
                  v-model="form.content.directions" name="intake-form-form-directions"
                  id="intake-form-form-directions"><?= $form_data ? $form_data[0]['form_directions'] : '' ?></textarea>

                <label for="intake-form-website-link">Website Link</label>
                <input v-model="form.content.websiteLink" type="text" name="intake-form-website-link"
                  id="intake-form-website-link">

                <label for="intake-form-exit-link">Exit Link</label>
                <input v-model="form.content.link" type="text" name="intake-form-exit-link" id="intake-form-exit-link">
                <p class="field_description">
                  If you need to redirect to another website, you can enter the URL here. When the user clicks Exit on your form, they will be taken to this link.
                </p>

              </div>
              <div class="flex flex-col">
                <label for="intake-form-navigation-logo">Upload Navigation Logo</label>
                <div v-if="logoPreview"
                  class="wrapper bg-gray-500 wrapper w-full h-full max-w-[332px] max-h-[70px] p-3">
                  <img class="object-cover w-full h-full aspect-video" :src="logoPreview" alt="">
                </div>
                <input v-else ref="logo" @change="handleLogoSelect" type="file" class="w-full">
                <div class="flex items-center justify-between mt-2 field_description">
                  <p class="">Note: We recommend this be the horizontal mockup of your logo</p>
                  <button type="button" v-if="logoPreview" @click="clearMedia('logo')">
                    <svg class='icon icon-bin'>
                      <use xlink:href='#icon-bin'></use>
                    </svg>
                  </button>
                </div>

                <label for="intake-form-practice-image">Practice or Doctor Image</label>
                <div v-if="imagePreview" class="bg-gray-500 wrapper w-full h-full max-w-[160px] max-h-[160px] p-3">
                  <img class="object-cover w-full h-full aspect-square" :src="imagePreview" alt="">
                </div>
                <input v-else ref="image" @change="handleImageSelect" type="file" class="w-full">
                <p v-if="validationMessage" class="paragraph-small">
                  {{ validationMessage }}
                </p>
                <div class="flex items-center justify-between mt-2 field_description">
                  <p class="">Note: This image will look best if the ratio is 1:1</p>
                  <button type="button" v-if="imagePreview" @click="clearMedia('image')">
                    <svg class='icon icon-bin'>
                      <use xlink:href='#icon-bin'></use>
                    </svg>
                  </button>
                </div>

                <label for="intake-form-practice-image">Preview</label>
                <div class="p-5 bg-brand-light-gray">
                  <div
                    class="relative w-full mb-2 mx-auto max-w-[316px] font-semibold paragraph-small text-brand-eggplant aspect-square">
                    <div
                      class="bg-white absolute flex items-center justify-center inset-0 text-center border border-brand-light-gray rounded-[10px] py-[35px] px-[55px] flex-col">
                      <p class="mb-2 hdg text-[13px]">
                        {{ form.content.title }}
                      </p>
                      <div class="mb-2 border rounded-full size-[52px] border-brand-light-gray flex-none">
                        <div v-if="imagePreview" class="w-full h-full">
                          <img class="object-cover w-full h-full rounded-full aspect-square" :src="imagePreview" alt="">
                        </div>
                      </div>
                      <p class="mb-5 tracking-wide text-brand-eggplant paragraph-small text-[7px]">
                        {{ form.content.imageCaption }}
                      </p>
                      <p class="mb-3 font-medium paragraph-default text-[8px]">
                        {{ form.content.content }}
                      </p>
                      <p class="paragraph-small text-[7px]">
                        {{ form.content.directions }}
                      </p>
                      <div class="mt-4 btn-primary text-[8px] pointer-events-none"
                        data-toggle-target="#patient-form__form, #patient-form__intro-page" data-toggle-class="is-open">
                        Begin Form
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bg-white form-settings__edit-colors" v-if="currentPage === 31">
            <div class="grid grid-cols-1 md:grid-cols-3">
              <!-- background color -->
              <div
                class="flex flex-col gap-2 px-8 py-5 border-b border-r border-brand-light-gray [&:nth-child(3)]:border-r-0">
                <span class="font-semibold text-brand-wicked paragraph-small">Background Color</span>
                <div class="grid grid-cols-2">
                  <label class="relative flex flex-col gap-2 w-fit" for="brand-background-color">
                    <div
                      class="flex cursor-pointer items-center border rounded-[4px] overflow-hidden w-fit border-brand-light-gray">
                      <div :style="{ backgroundColor: form.colors.backgroundColor }"
                        class="w-8 h-8 border-r border-brand-light-gray"></div>
                      <span class="px-3">
                        Select Color
                      </span>
                      <input v-model="form.colors.backgroundColor" class="w-[1px] h-[4px] pickr opacity-0" type="color"
                        id="brand-background-color" name="brand-background-color" />
                    </div>
                  </label>

                  <div class="">
                    <input v-model="form.colors.backgroundColor" class="h-[34px] w-[80px] mb-0 border border-brand-light-gray color-picker" type="text"
                        id="brand-background-color" name="brand-background-color" />
                  </div>
                </div>
              </div>
              <!-- card shadow -->
              <div
                class="flex flex-col gap-2 px-8 py-5 border-b border-r border-brand-light-gray [&:nth-child(3)]:border-r-0">
                <span class="font-semibold text-brand-wicked paragraph-small">Card Shadow</span>
                <div class="grid grid-cols-2">
                  <label class="relative flex flex-col gap-2 w-fit" for="brand-card-shadow">
                    <div
                      class="flex cursor-pointer items-center border rounded-[4px] overflow-hidden w-fit border-brand-light-gray">
                      <div :style="{ backgroundColor: form.colors.cardShadow }"
                        class="w-8 h-8 border-r swatch border-brand-light-gray"></div>
                      <span class="px-3">
                        Select Color
                      </span>
                    </div>
                    <input v-model="form.colors.cardShadow" class="w-[0px] h-[0px] flex-none pickr opacity-0 absolute left-0 bottom-0"
                      data-hex="<?php echo $colors['brand_card_shadow']; ?>" type="color" id="brand-card-shadow"
                      name="brand-card-shadow" />
                  </label>

                  <div>
                    <input v-model="form.colors.cardShadow" class="h-[34px] w-[80px] mb-0 border border-brand-light-gray color-picker"
                      data-hex="<?php echo $colors['brand_card_shadow']; ?>" type="text" id="brand-card-shadow-text"
                      name="brand-card-shadow-text" />
                  </div>

                </div>
              </div>
              <!-- checkmark inactive button -->
              <div
                class="flex flex-col gap-2 px-8 py-5 border-b border-r border-brand-light-gray [&:nth-child(3)]:border-r-0">
                <span class="font-semibold text-brand-wicked paragraph-small">Checkmark Inactive Button Color</span>
                <div class="grid grid-cols-2">
                  <label class="relative flex flex-col gap-2 w-fit" for="brand-checkmark-inactive-button">
                    <div
                      class="flex cursor-pointer items-center border rounded-[4px] overflow-hidden w-fit border-brand-light-gray">
                      <div :style="{ backgroundColor: form.colors.checkmarkInactiveButtonColor }"
                        class="w-8 h-8 border-r swatch border-brand-light-gray"></div>
                      <span class="px-3">
                        Select Color
                      </span>
                    </div>
                    <input v-model="form.colors.checkmarkInactiveButtonColor"
                      class="w-[0px] h-[0px] flex-none pickr opacity-0 absolute left-0 bottom-0" type="color" id="brand-checkmark-inactive-button"
                      name="brand-checkmark-inactive-button" />
                  </label>

                  <div>
                    <input v-model="form.colors.checkmarkInactiveButtonColor"
                      class="h-[34px] w-[80px] mb-0 border border-brand-light-gray color-picker" type="text"
                      id="brand-checkmark-inactive-button-text" name="brand-checkmark-inactive-button-text" />
                  </div>
                </div>
              </div>
              <!-- heading text color -->
              <div
                class="flex flex-col gap-2 border-b px-8 py-5 border-r border-brand-light-gray [&:nth-child(3)]:border-r-0">
                <span class="font-semibold text-brand-wicked paragraph-small">Heading Text Color</span>
                <div class="grid grid-cols-2">
                  <label class="relative flex flex-col gap-2 w-fit" for="brand-heading-text-color">
                    <div
                      class="flex cursor-pointer items-center border rounded-[4px] overflow-hidden w-fit border-brand-light-gray">
                      <div :style="{ backgroundColor: form.colors.headingTextColor }"
                        class="w-8 h-8 border-r swatch border-brand-light-gray"></div>
                      <span class="px-3">
                        Select Color
                      </span>
                    </div>
                    <input v-model="form.colors.headingTextColor" class="w-[0px] h-[0px] flex-none pickr opacity-0 absolute left-0 bottom-0"
                      type="color" id="brand-heading-text-color" name="brand-heading-text-color" />
                  </label>

                  <div class="">
                    <input v-model="form.colors.headingTextColor" class="h-[34px] w-[80px] mb-0 border border-brand-light-gray color-picker"
                      type="text" id="brand-heading-text-color" name="brand-heading-text-color" />
                  </div>
                </div>
              </div>
              <!-- divider line color -->
              <div
                class="flex flex-col gap-2 border-b px-8 py-5 border-r border-brand-light-gray [&:nth-child(3)]:border-r-0">
                <span class="font-semibold text-brand-wicked paragraph-small">Divider Line Color</span>
                <div class="grid grid-cols-2">
                  <label class="relative flex flex-col gap-2 w-fit" for="brand-divider-line-color">
                    <div
                      class="flex cursor-pointer items-center border rounded-[4px] overflow-hidden w-fit border-brand-light-gray">
                      <div :style="{ backgroundColor: form.colors.dividerLineColor }"
                        class="w-8 h-8 border-r swatch border-brand-light-gray"></div>
                      <span class="px-3">
                        Select Color
                      </span>
                    </div>
                    <input v-model="form.colors.dividerLineColor" class="w-[0px] h-[0px] flex-none pickr opacity-0 absolute left-0 bottom-0"
                    type="color" id="brand-divider-line-color" name="brand-divider-line-color" />
                  </label>
                  <div>
                    <input v-model="form.colors.dividerLineColor" class="h-[34px] w-[80px] mb-0 border border-brand-light-gray color-picker"
                      type="text" id="brand-divider-line-color" name="brand-divider-line-color" />
                  </div>
                </div>
              </div>
              <!-- checkmark inactive text color -->
              <div
                class="flex flex-col gap-2 border-b px-8 py-5 border-r border-brand-light-gray [&:nth-child(3)]:border-r-0">
                <span class="font-semibold text-brand-wicked paragraph-small">Checkmark Inactive Text Color</span>
                <div class="grid grid-cols-2">
                  <label class="relative flex flex-col gap-2 w-fit" for="brand-checkmark-inactive-text-color">
                    <div
                      class="flex cursor-pointer items-center border rounded-[4px] overflow-hidden w-fit border-brand-light-gray">
                      <div :style="{ backgroundColor: form.colors.checkmarkInactiveTextColor }"
                        class="w-8 h-8 border-r swatch border-brand-light-gray"></div>
                      <span class="px-3">
                        Select Color
                      </span>
                    </div>
                    <input v-model="form.colors.checkmarkInactiveTextColor"
                      class="w-[0px] h-[0px] flex-none pickr opacity-0 absolute left-0 bottom-0" type="color"
                      id="brand-checkmark-inactive-text-color" name="brand-checkmark-inactive-text-color" />
                  </label>

                  <div class="">
                    <input v-model="form.colors.checkmarkInactiveTextColor"
                      class="h-[34px] w-[80px] mb-0 border border-brand-light-gray color-picker" type="text"
                      id="brand-checkmark-inactive-text-color" name="brand-checkmark-inactive-text-color" />
                  </div>
                </div>
              </div>
              <!-- Body Text Color -->
              <div
                class="flex flex-col gap-2 border-b px-8 py-5 border-r border-brand-light-gray [&:nth-child(3)]:border-r-0">
                <span class="font-semibold text-brand-wicked paragraph-small">Body Text Color</span>
                <div class="grid grid-cols-2">
                  <label class="relative flex flex-col gap-2 w-fit" for="brand-body-text-color">
                    <div
                      class="flex cursor-pointer items-center border rounded-[4px] overflow-hidden w-fit border-brand-light-gray">
                      <div :style="{ backgroundColor: form.colors.bodyTextColor }"
                        class="w-8 h-8 border-r swatch border-brand-light-gray"></div>
                      <span class="px-3">
                        Select Color
                      </span>
                    </div>
                    <input v-model="form.colors.bodyTextColor" class="w-[0px] h-[0px] flex-none pickr opacity-0 absolute left-0 bottom-0"
                    type="color" id="brand-body-text-color" name="brand-body-text-color" />
                  </label>
                  <div>
                    <input v-model="form.colors.bodyTextColor" class="h-[34px] w-[80px] mb-0 border border-brand-light-gray color-picker"
                      type="text" id="brand-body-text-color" name="brand-body-text-color" />
                  </div>
                </div>
              </div>
              <!-- Primary Button Color -->
              <div
                class="flex flex-col gap-2 border-b px-8 py-5 border-r border-brand-light-gray [&:nth-child(3)]:border-r-0">
                <span class="font-semibold text-brand-wicked paragraph-small">Primary Button Color</span>
                <div class="grid grid-cols-2">
                  <label class="relative flex flex-col gap-2 w-fit" for="brand-primary-button-color">
                    <div
                      class="flex cursor-pointer items-center border rounded-[4px] overflow-hidden w-fit border-brand-light-gray">
                      <div :style="{ backgroundColor: form.colors.primaryButtonColor }"
                        class="w-8 h-8 border-r swatch border-brand-light-gray"></div>
                      <span class="px-3">
                        Select Color
                      </span>
                    </div>
                    <input v-model="form.colors.primaryButtonColor" class="w-[0px] h-[0px] flex-none pickr opacity-0 absolute left-0 bottom-0"
                    type="color" id="brand-primary-button-color" name="brand-primary-button-color" />
                  </label>
                  <div>
                    <input v-model="form.colors.primaryButtonColor" class="h-[34px] w-[80px] mb-0 border border-brand-light-gray color-picker"
                      type="text" id="brand-primary-button-color" name="brand-primary-button-color" />
                  </div>
                </div>
              </div>
              <!-- Checkmark Hover Button Color -->
              <div
                class="flex flex-col gap-2 border-b px-8 py-5 border-r border-brand-light-gray [&:nth-child(3)]:border-r-0">
                <span class="font-semibold text-brand-wicked paragraph-small">Checkmark Hover Button Color</span>
                <div class="grid grid-cols-2">
                  <label class="relative flex flex-col gap-2 w-fit" for="brand-checkmark-hover-button-color">
                    <div
                      class="flex cursor-pointer items-center border rounded-[4px] overflow-hidden w-fit border-brand-light-gray">
                      <div :style="{ backgroundColor: form.colors.checkmarkHoverButtonColor }"
                        class="w-8 h-8 border-r swatch border-brand-light-gray"></div>
                      <span class="px-3">
                        Select Color
                      </span>
                    </div>
                    <input v-model="form.colors.checkmarkHoverButtonColor"
                    class="w-[0px] h-[0px] flex-none pickr opacity-0 absolute left-0 bottom-0" type="color"
                    id="brand-checkmark-hover-button-color" name="brand-checkmark-hover-button-color" />
                  </label>
                  <div>
                    <input v-model="form.colors.checkmarkHoverButtonColor"
                      class="h-[34px] w-[80px] mb-0 border border-brand-light-gray color-picker" type="text"
                      id="brand-checkmark-hover-button-color" name="brand-checkmark-hover-button-color" />
                  </div>
                </div>
              </div>
              <!-- Nav Color -->
              <div
                class="flex flex-col gap-2 border-b px-8 py-5 border-r border-brand-light-gray [&:nth-child(3)]:border-r-0">
                <span class="font-semibold text-brand-wicked paragraph-small">Nav Color</span>
                <div class="grid grid-cols-2">
                  <label class="relative flex flex-col gap-2 w-fit" for="brand-nav-color">
                    <div
                      class="flex cursor-pointer items-center border rounded-[4px] overflow-hidden w-fit border-brand-light-gray">
                      <div :style="{ backgroundColor: form.colors.navColor }"
                        class="w-8 h-8 border-r swatch border-brand-light-gray"></div>
                      <span class="px-3">
                        Select Color
                      </span>
                    </div>
                    <input v-model="form.colors.navColor" class="w-[0px] h-[0px] flex-none pickr opacity-0 absolute left-0 bottom-0" type="color"
                    id="brand-nav-color" name="brand-nav-color" />
                  </label>
                  <div>
                    <input v-model="form.colors.navColor" class="h-[34px] w-[80px] mb-0 border border-brand-light-gray color-picker" type="text"
                      id="brand-nav-color" name="brand-nav-color" />
                  </div>
                </div>
              </div>
              <!-- Primary Button Text Color -->
              <div
                class="flex flex-col gap-2 border-b px-8 py-5 border-r border-brand-light-gray [&:nth-child(3)]:border-r-0">
                <span class="font-semibold text-brand-wicked paragraph-small">Primary Button Text Color</span>
                <div class="grid grid-cols-2">
                  <label class="relative flex flex-col gap-2 w-fit" for="brand-primary-button-text">
                    <div
                      class="flex cursor-pointer items-center border rounded-[4px] overflow-hidden w-fit border-brand-light-gray">
                      <div :style="{ backgroundColor: form.colors.primaryButtonTextColor }"
                        class="w-8 h-8 border-r swatch border-brand-light-gray"></div>
                      <span class="px-3">
                        Select Color
                      </span>
                    </div>
                    <input v-model="form.colors.primaryButtonTextColor" class="w-[0px] h-[0px] flex-none pickr opacity-0 absolute left-0 bottom-0"
                    type="color" id="brand-primary-button-text" name="brand-primary-button-text" />
                  </label>
                  <div>
                    <input v-model="form.colors.primaryButtonTextColor" class="h-[34px] w-[80px] mb-0 border border-brand-light-gray color-picker"
                      type="text" id="brand-primary-button-text" name="brand-primary-button-text" />
                  </div>
                </div>
              </div>
              <!-- Checkmark Hover Text Color -->
              <div
                class="flex flex-col gap-2 border-b px-8 py-5 border-r border-brand-light-gray [&:nth-child(3)]:border-r-0">
                <span class="font-semibold text-brand-wicked paragraph-small">Checkmark Hover Text Color</span>
                <div class="grid grid-cols-2">
                  <label class="relative flex flex-col gap-2 w-fit" for="brand-checkmark-hover-text-color">
                    <div
                      class="flex cursor-pointer items-center border rounded-[4px] overflow-hidden w-fit border-brand-light-gray">
                      <div :style="{ backgroundColor: form.colors.checkmarkHoverTextColor }"
                        class="w-8 h-8 border-r swatch border-brand-light-gray"></div>
                      <span class="px-3">
                        Select Color
                      </span>
                    </div>
                    <input v-model="form.colors.checkmarkHoverTextColor" class="w-[0px] h-[0px] flex-none pickr opacity-0 absolute left-0 bottom-0"
                    type="color" id="brand-checkmark-hover-text-color" name="brand-checkmark-hover-text-color" />
                  </label>
                  <div>
                    <input v-model="form.colors.checkmarkHoverTextColor" class="h-[34px] w-[80px] mb-0 border border-brand-light-gray color-picker"
                      type="text" id="brand-checkmark-hover-text-color" name="brand-checkmark-hover-text-color" />
                  </div>
                </div>
              </div>
              <!-- Exit Link Text Color -->
              <div
                class="flex flex-col gap-2 border-b px-8 py-5 border-r border-brand-light-gray [&:nth-child(3)]:border-r-0">
                <span class="font-semibold text-brand-wicked paragraph-small">Exit Link Text Color</span>
                <div class="grid grid-cols-2">
                  <label class="relative flex flex-col gap-2 w-fit" for="brand-exit-link-text-color">
                    <div
                      class="flex cursor-pointer items-center border rounded-[4px] overflow-hidden w-fit border-brand-light-gray">
                      <div :style="{ backgroundColor: form.colors.exitLinkTextColor }"
                        class="w-8 h-8 border-r swatch border-brand-light-gray"></div>
                      <span class="px-3">
                        Select Color
                      </span>
                    </div>
                    <input v-model="form.colors.exitLinkTextColor" class="w-[0px] h-[0px] flex-none pickr opacity-0 absolute left-0 bottom-0"
                    type="color" id="brand-exit-link-text-color" name="brand-exit-link-text-color" />
                  </label>
                  <div>
                    <input v-model="form.colors.exitLinkTextColor" class="h-[34px] w-[80px] mb-0 border border-brand-light-gray color-picker"
                      type="text" id="brand-exit-link-text-color" name="brand-exit-link-text-color" />
                  </div>
                </div>
              </div>
              <!-- Primary Button Hover Color -->
              <div
                class="flex flex-col gap-2 border-b px-8 py-5 border-r border-brand-light-gray [&:nth-child(3)]:border-r-0">
                <span class="font-semibold text-brand-wicked paragraph-small">Primary Button Hover Color</span>
                <div class="grid grid-cols-2">
                  <label class="relative flex flex-col gap-2 w-fit" for="brand-primary-button-hover-color">
                    <div
                      class="flex cursor-pointer items-center border rounded-[4px] overflow-hidden w-fit border-brand-light-gray">
                      <div :style="{ backgroundColor: form.colors.primaryButtonHoverColor }"
                        class="w-8 h-8 border-r swatch border-brand-light-gray"></div>
                      <span class="px-3">
                        Select Color
                      </span>
                    </div>
                    <input v-model="form.colors.primaryButtonHoverColor" class="w-[0px] h-[0px] flex-none pickr opacity-0 absolute left-0 bottom-0"
                    type="color" id="brand-primary-button-hover-color" name="brand-primary-button-hover-color" />
                  </label>
                  <div>
                    <input v-model="form.colors.primaryButtonHoverColor" class="h-[34px] w-[80px] mb-0 border border-brand-light-gray color-picker"
                      type="text" id="brand-primary-button-hover-color" name="brand-primary-button-hover-color" />
                  </div>
                </div>
              </div>
              <!-- Checkmark Selected Button Color -->
              <div
                class="flex flex-col gap-2 border-b px-8 py-5 border-r border-brand-light-gray [&:nth-child(3)]:border-r-0">
                <span class="font-semibold text-brand-wicked paragraph-small">Checkmark Selected Button Color</span>
                <div class="grid grid-cols-2">
                  <label class="relative flex flex-col gap-2 w-fit" for="brand-checkmark-selected-button-color">
                    <div
                      class="flex cursor-pointer items-center border rounded-[4px] overflow-hidden w-fit border-brand-light-gray">
                      <div :style="{ backgroundColor: form.colors.checkmarkSelectedButtonColor }"
                        class="w-8 h-8 border-r swatch border-brand-light-gray"></div>
                      <span class="px-3">
                        Select Color
                      </span>
                    </div>
                    <input v-model="form.colors.checkmarkSelectedButtonColor"
                    class="w-[0px] h-[0px] flex-none pickr opacity-0 absolute left-0 bottom-0" type="color"
                    id="brand-checkmark-selected-button-color" name="brand-checkmark-selected-button-color" />
                  </label>
                  <div>
                    <input v-model="form.colors.checkmarkSelectedButtonColor"
                      class="h-[34px] w-[80px] mb-0 border border-brand-light-gray color-picker" type="text"
                      id="brand-checkmark-selected-button-color" name="brand-checkmark-selected-button-color" />
                  </div>
                </div>
              </div>
              <!-- Exit Link Hover Text Color -->
              <div
                class=" border-b md:border-b-0 flex flex-col gap-2 px-8 py-5 border-r border-brand-light-gray [&:nth-child(3)]:border-r-0">
                <span class="font-semibold text-brand-wicked paragraph-small">Exit Link Hover Text Color</span>
                <div class="grid grid-cols-2">
                  <label class="relative flex flex-col gap-2 w-fit" for="brand-exit-link-hover-color">
                    <div
                      class="flex cursor-pointer items-center border rounded-[4px] overflow-hidden w-fit border-brand-light-gray">
                      <div :style="{ backgroundColor: form.colors.exitLinkHoverTextColor }"
                        class="w-8 h-8 border-r swatch border-brand-light-gray"></div>
                      <span class="px-3">
                        Select Color
                      </span>
                    </div>
                    <input v-model="form.colors.exitLinkHoverTextColor" class="w-[0px] h-[0px] flex-none pickr opacity-0 absolute left-0 bottom-0"
                      type="color" id="brand-exit-link-hover-color" name="brand-exit-link-hover-color" />
                  </label>
                  <div>
                    <input v-model="form.colors.exitLinkHoverTextColor" class="h-[34px] w-[80px] mb-0 border border-brand-light-gray color-picker"
                      type="text" id="brand-exit-link-hover-color" name="brand-exit-link-hover-color" />
                  </div>
                </div>
              </div>
              <!-- Primary Button Hover Text Color -->
              <div
                class="flex flex-col gap-2 border-b md:border-b-0 px-8 py-5 border-r border-brand-light-gray [&:nth-child(3)]:border-r-0">
                <span class="font-semibold text-brand-wicked paragraph-small">Primary Button Hover Text Color</span>
                <div class="grid grid-cols-2">
                  <label class="relative flex flex-col gap-2 w-fit" for="brand-primary-button-hover-text-color">
                    <div
                      class="flex cursor-pointer items-center border rounded-[4px] overflow-hidden w-fit border-brand-light-gray">
                      <div :style="{ backgroundColor: form.colors.primaryButtonHoverTextColor }"
                        class="w-8 h-8 border-r swatch border-brand-light-gray"></div>
                      <span class="px-3">
                        Select Color
                      </span>
                    </div>
                    <input v-model="form.colors.primaryButtonHoverTextColor"
                    class="w-[0px] h-[0px] flex-none pickr opacity-0 absolute left-0 bottom-0" type="color"
                    id="brand-primary-button-hover-text-color" name="brand-primary-button-hover-text-color" />
                  </label>
                  <div>
                    <input v-model="form.colors.primaryButtonHoverTextColor"
                      class="h-[34px] w-[80px] mb-0 border border-brand-light-gray color-picker" type="text"
                      id="brand-primary-button-hover-text-color" name="brand-primary-button-hover-text-color" />
                  </div>
                </div>
              </div>
              <!-- Checkmark Selected Text Color -->
              <div
                class="flex flex-col gap-2 px-8 border-b md:border-b-0 py-5 border-r border-brand-light-gray [&:nth-child(3)]:border-r-0">
                <span class="font-semibold text-brand-wicked paragraph-small">Checkmark Hover Text Color</span>
                <div class="grid grid-cols-2">
                  <label class="relative flex flex-col gap-2 w-fit" for="brand-checkmark-selected-text-color">
                    <div
                      class="flex cursor-pointer items-center border rounded-[4px] overflow-hidden w-fit border-brand-light-gray">
                      <div :style="{ backgroundColor: form.colors.checkmarkHoverTextColor }"
                        class="w-8 h-8 border-r swatch border-brand-light-gray"></div>
                      <span class="px-3">
                        Select Color
                      </span>
                    </div>
                    <input v-model="form.colors.checkmarkHoverTextColor" class="w-[0px] h-[0px] flex-none pickr opacity-0 absolute left-0 bottom-0"
                    type="color" id="brand-checkmark-selected-text-color" name="brand-checkmark-selected-text-color" />
                  </label>
                  <div>
                    <input v-model="form.colors.checkmarkHoverTextColor" class="h-[34px] w-[80px] mb-0 border border-brand-light-gray color-picker"
                      type="text" id="brand-checkmark-selected-text-color" name="brand-checkmark-selected-text-color" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bg-white form-settings__edit-confirmation" v-if="currentPage === 3">
            <div class="w-1/2 px-10 py-8">

              <label for="intake-form-confirmation-heading">Confirmation Heading<span class="required">*</span></label>
              <input
                :class="{ 'border border-form-error': errorConfirmationHeading, 'test': !errorConfirmationHeading }"
                v-model="form.confirmation.heading" type="text" id="intake-form-confirmation-heading">

              <label for="intake-form-confirmation-paragraph">Confirmation Paragraph<span
                  class="required">*</span></label>
              <textarea v-model="form.confirmation.paragraph" class="mb-0" :class="{ 'border border-form-error': errorConfirmationParagraph, 'test': !errorConfirmationParagraph }" name="intake-form-confirmation-paragraph"
                id="intake-form-confirmation-paragraph"></textarea>

            </div>

          </div>
          <div class="bg-white form-settings__edit-email" v-if="currentPage === 4">
            <div class="grid grid-cols-2 gap-20 px-10 py-8 bg-white">
              <div>
                <label for="email-results-email">Results Email<span class="required">*</span></label>
                <input :class="{ 'border border-form-error': errorEmail, 'test': !errorEmail }"
                  v-model="form.email.resultsEmail" type="email" id="email-results-email">

                <label for="email-introduction">Introduction<span class="required">*</span></label>
                <input :class="{ 'border border-form-error': errorEmailSubject, 'test': !errorEmailSubject }"
                  v-model="form.email.introduction" type="text" id="email-introduction">

                <label for="email-message">Message<span class="required">*</span></label>
                <textarea :class="{ 'border border-form-error': errorEmailMessage, 'test': !errorEmailMessage }"
                  v-model="form.email.message" id="email-message"></textarea>

                <label for="intake-form-navigation-logo">Upload Navigation Logo</label>
                <div v-if="navLogoPreview"
                  class="wrapper bg-gray-500 wrapper w-full h-full max-w-[332px] max-h-[70px] p-3">
                  <img class="object-cover w-full h-full aspect-video" :src="navLogoPreview" alt="">
                </div>
                <input v-else ref="navLogo" @change="handleNavLogoSelect" type="file" class="w-full">
                <div class="flex items-center justify-between mt-2 field_description">
                  <p class="">Note: We recommend this be the horizontal mockup of your logo</p>
                  <button type="button" v-if="navLogoPreview" @click="clearMedia('navLogo')">
                    <svg class='icon icon-bin'>
                      <use xlink:href='#icon-bin'></use>
                    </svg>
                  </button>
                </div>
              </div>

              <div>
                <div class="hidden grid-cols-2 border border-brand-light-gray">
                  <!-- Email Background -->
                  <div class="flex flex-col gap-2 px-8 py-5 border-b border-r border-brand-light-gray">
                    <span class="font-semibold text-brand-wicked paragraph-small">Background Color</span>
                    <div class="flex flex-col">
                      <label class="relative flex flex-col gap-2 w-fit" for="email-background-color">
                        <div
                          class="flex cursor-pointer items-center border rounded-[4px] overflow-hidden w-fit border-brand-light-gray">
                          <div :style="{ backgroundColor: form.email.backgroundColor }"
                            class="w-8 h-8 border-r swatch border-brand-light-gray"></div>
                          <span class="px-3">
                            Select Color
                          </span>
                        </div>
                        <input v-model="form.email.backgroundColor" class="w-[0px] h-[0px] flex-none pickr opacity-0 absolute left-0 -bottom-[38px]"
                        type="color" id="email-background-color" name="email-background-color" />
                      </label>
                      <div>
                        <input v-model="form.email.backgroundColor" class="h-[34px] mb-0 mt-1 color-picker"
                          type="text" id="email-background-color" name="email-background-color" />
                      </div>

                    </div>
                  </div>
                  <!-- Heading Text -->
                  <div
                    class="flex flex-col gap-2 px-8 py-5 border-b border-brand-light-gray [&:nth-child(3)]:border-r-0">
                    <span class="font-semibold text-brand-wicked paragraph-small">Heading Text Color</span>
                    <div class="flex flex-col">
                      <label class="relative flex flex-col gap-2 w-fit" for="email-heading-text-color">
                        <div
                          class="flex cursor-pointer items-center border rounded-[4px] overflow-hidden w-fit border-brand-light-gray">
                          <div :style="{ backgroundColor: form.email.headingTextColor }"
                            class="w-8 h-8 border-r swatch border-brand-light-gray"></div>
                          <span class="px-3">
                            Select Color
                          </span>
                        </div>
                        <input v-model="form.email.headingTextColor" class="w-[0px] h-[0px] flex-none pickr opacity-0 absolute left-0 -bottom-[38px]"
                        type="color" id="email-heading-text-color" name="email-heading-text-color" />
                      </label>
                      <div>
                        <input v-model="form.email.headingTextColor" class="h-[34px] mb-0 mt-1 color-picker"
                          type="text" id="email-heading-text-color" name="email-heading-text-color" />
                      </div>
                    </div>
                  </div>
                  <!-- Body Text -->
                  <div class="flex flex-col gap-2 px-8 py-5 border-r border-brand-light-gray ">
                    <span class="font-semibold text-brand-wicked paragraph-small">Body Text Color</span>
                    <div class="flex flex-col">
                      <label class="relative flex flex-col gap-2 w-fit" for="email-body-text-color">
                        <div
                          class="flex cursor-pointer items-center border rounded-[4px] overflow-hidden w-fit border-brand-light-gray">
                          <div :style="{ backgroundColor: form.email.bodyTextColor }"
                            class="w-8 h-8 border-r swatch border-brand-light-gray"></div>
                          <span class="px-3">
                            Select Color
                          </span>
                        </div>
                        <input v-model="form.email.bodyTextColor" class="w-[0px] h-[0px] flex-none pickr opacity-0 absolute left-0 -bottom-[38px]"
                        data-hex="<?php echo $colors['email_body_text'] ?>" type="color" id="email-body-text-color"
                        name="email-body-text-color" />
                      </label>
                      <div>
                        <input v-model="form.email.bodyTextColor" class="h-[34px] mb-0 mt-1 color-picker"
                          data-hex="<?php echo $colors['email_body_text'] ?>" type="text" id="email-body-text-color"
                          name="email-body-text-color" />
                      </div>
                    </div>
                  </div>
                  <!-- Line Divider -->
                  <div class="flex flex-col gap-2 px-8 py-5 [&:nth-child(3)]:border-r-0">
                    <span class="font-semibold text-brand-wicked paragraph-small">Line Divider Color</span>
                    <div class="flex flex-col">
                      <label class="relative flex flex-col gap-2 w-fit" for="email-line-divider-color">
                        <div
                          class="flex cursor-pointer items-center border rounded-[4px] overflow-hidden w-fit border-brand-light-gray">
                          <div :style="{ backgroundColor: form.email.lineDividerColor }"
                            class="w-8 h-8 border-r swatch border-brand-light-gray"></div>
                          <span class="px-3">
                            Select Color
                          </span>
                        </div>
                        <input v-model="form.email.lineDividerColor" class="w-[0px] h-[0px] flex-none pickr opacity-0 absolute left-0 -bottom-[38px]"
                        type="color" id="email-line-divider-color" name="email-line-divider-color" />
                      </label>
                      <div>
                        <input v-model="form.email.lineDividerColor" class="h-[34px] mb-0 mt-1 color-picker"
                          type="text" id="email-line-divider-color" name="email-line-divider-color" />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mt-5 mb-2 font-semibold text-brand-wicked paragraph-small">Preview</div>

                <div class="p-5 bg-brand-light-gray">
                  <div
                    class="relative w-full mb-2 mx-auto max-w-[316px] font-semibold paragraph-small text-brand-eggplant">
                    <div :style="{ backgroundColor: form?.email?.backgroundColor }"
                      class="flex items-center justify-center inset-0 border border-brand-light-gray py-[14.4px] px-[38.4px] flex-col">
                      <email-preview :form="form" :sections="sections"></email-preview>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          </div>
          </Transition>

        </div>
      </div>
    </div> 
    <div v-if="showDeleteFormConfirmationPopup" @click="closePopup" class="fixed -translate-x-1/2 -translate-y-1/2 z-[90] size-full bg-brand-scrim top-1/2 left-1/2"></div>
    <div v-if="showDeleteFormConfirmationPopup" class="fixed w-[432px] max-w-[90vw] z-[91] flex flex-col rounded-[8px] md:py-12 md:px-10 p-6 mx-auto bg-white top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2">
      <button type="button" class="mfp-close size-10" @click="closePopup">
        <svg class="rotate-45 pointer-events-none size-6 icon icon-plus text-brand-medium-gray" aria-hidden="true"><use xlink:href="#icon-plus"></use></svg>
      </button>
      <p class="hdg-5 text-brand-wicked">
        Are you sure you want to delete this intake form?
      </p>

      <div class="flex items-center justify-end gap-4 mt-8 form">
        <input
        :class="{ 'border border-form-error' : errorMessage, '' : !errorMessage }"
        class="mt-0 form-submit btn-secondary" type="submit" name="delete_form" value="Cancel" @click="closePopup">
        <input
          :class="{ 'border border-form-error' : errorMessage, '' : !errorMessage }"
          class="mt-0 form-submit btn-primary" type="submit" name="delete_form" value="Delete" @click="deleteForm">

        <div v-if="errorMessage" class="mt-2 text-form-error">{{ errorMessage }}</div>
      </div>
    </div>

    <!-- clear media confirmation popup -->
    <div v-if="showClearMediaConfirmationPopup" @click="closePopup" class="fixed -translate-x-1/2 -translate-y-1/2 z-[90] size-full bg-brand-scrim top-1/2 left-1/2"></div>
    <div v-if="showClearMediaConfirmationPopup" class="fixed w-[432px] max-w-[90vw] z-[91] flex flex-col rounded-[8px] md:py-12 md:px-10 p-6 mx-auto bg-white top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2">
      <button type="button" class="mfp-close size-10" @click="closePopup">
        <svg class="rotate-45 pointer-events-none size-6 icon icon-plus text-brand-medium-gray" aria-hidden="true"><use xlink:href="#icon-plus"></use></svg>
      </button>
      <p class="hdg-5 text-brand-wicked">
        Are you sure you want to remove this image?
      </p>
      <p class="mt-2 paragraph-small text-brand-medium-gray">This action cannot be undone.</p>
      <div class="flex items-center justify-end gap-4 mt-8 form">
        <input class="mt-0 form-submit btn-secondary" type="button" value="Cancel" @click="closePopup">
        <input class="mt-0 form-submit btn-primary" type="button" value="Remove" @click="executeClearMedia">
      </div>
    </div>

    <!-- create section popup -->
    <div v-if="showNewSectionPopup" @click="closePopup" class="fixed -translate-x-1/2 -translate-y-1/2 z-[90] size-full bg-brand-scrim top-1/2 left-1/2"></div>
    <add-new-section v-if="showNewSectionPopup" :sectionName="sectionName" :sectionDirections="sectionDirections" :errorMessage="errorMessage"></add-new-section>


    <!-- submit button -->
    <intake-footer :page="currentPage === 3 ? 3 : currentPage === 4 ? 4 : 1" :status="status" :totalPages="4" :saveText="saveText" @triggerToDashboard="publishIntakeForm"
      @triggerToNextPage="handleTriggerToNextPage" @triggerSave="validateAndSavePage" @triggerUpdateSave="publishIntakeForm" v-if="status !== 'publish'"></intake-footer>
    <intake-footer :page="currentPage" :status="status" :totalPages="totalPages" :saveText="saveText" @triggerToDashboard="publishIntakeForm"
      @triggerToNextPage="handleTriggerToNextPage" @triggerSave="validateAndSavePage" @triggerUpdateSave="publishIntakeForm" v-if="status === 'publish'"></intake-footer>
    <loading :showLoading="isLoading"></loading>
  </form>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onUnmounted, watch } from 'vue';
import axios from 'axios';

const props = defineProps({
  postId: Number,
  userId: Number,
  postHash: String,
  sections: Array,
  title: String,
  form: Object,
  imageUrl: String,
  logoUrl: String,
  status: String,
  formColors: Object,
  emailColors: Object,
  formPracticeName: String,
  formNavigationLogo: Object,
  formPracticeOrDoctorImage: Object,
  formImageCaption: String,
  formWebsiteLink: String,
  formExitLink: String,
});

const reactiveSections = reactive([...props.sections]);
const imagePreview = ref(null);
const logoPreview = ref(null);
const imageFile = ref(null);
const logoFile = ref(null);
const validationMessage = ref(null);
const isRunning = ref(false);
const logo = ref(null);
const image = ref(null);
const isLoading = ref(false);
const isSaving = ref(false);
const navLogoPreview = ref(null);
const navLogoFile = ref(null);
const navLogo = ref(null);
const errorMessage = ref(false);
const errorMessageText = ref('Please review and fill out all required fields before proceeding.');
const errorTitle = ref(false);
const errorPractice = ref(false);
const errorContent = ref(false);
const errorDirections = ref(false);
const errorConfirmationHeading = ref(false);
const errorConfirmationParagraph = ref(false);
const errorEmail = ref(false);
const errorEmailSubject = ref(false);
const errorEmailMessage = ref(false);
const saveText = ref('Update');
const saveStatus = ref('');
// Check URL for step parameter
const urlParams = new URLSearchParams(window.location.search);
const stepParam = urlParams.get('step');
const currentPage = ref(props.status === 'publish' ? 2 : (stepParam === '3' ? 3 : stepParam === '4' ? 4 : 1));
const totalPages = ref(4);
const showDeleteFormConfirmationPopup = ref(false);
const showNewSectionPopup = ref(false);
const showClearMediaConfirmationPopup = ref(false);
const pendingClearMediaType = ref(null);

const deleteForm = async () => {
  if (!isRunning.value) {
    try {
      const { data } = await axios.post(
        `${siteInfo.wpApiSettings.ll}intake/delete`,
        {
          postId: props.postId,
        },
        {
          headers: {
            'X-WP-Nonce': siteInfo.wpApiSettings.nonce,
            'X-Requested-With': 'XMLHttpRequest'
          },
        }
      );
      window.location.href = "/";
    } catch (error) {
      console.error('Error publishing intake form:', error);
      return false;
    }
  }
}

const updateShowDeleteFormConfirmationPopup = () => {
  showDeleteFormConfirmationPopup.value = true;
}

const closePopup = () => {
  showDeleteFormConfirmationPopup.value = false;
  showClearMediaConfirmationPopup.value = false;
  pendingClearMediaType.value = null;
};

const togglePageView = (index) => {
  currentPage.value = index;
}

const handleLoadingUpdate = (loading) => {
  isLoading.value = loading;
}

const handleSectionsUpdate = (updatedSections) => {
  reactiveSections.splice(0, reactiveSections.length, ...updatedSections);
}

const progress = computed(() => {
  return (2 / props.totalPages) * 100;
});

const headerMessage = computed(() => {
  let msg = '';
  switch (currentPage.value) {
    case 1:
      msg = props.status === 'publish' ? 'Update your intake form' : 'Create your intake form';
      break;
    case 2:
      msg = 'Edit form content';
      break;
    case 31:
      msg = '';
      break;
    case 3:
      msg = props.status === 'publish' ? 'Update confirmation' : 'Setup confirmation';
      break;
    case 4:
      msg = props.status === 'publish' ? 'Update email' : 'Setup email';
      break;
  }
  return msg;
});

const subheaderMessage = computed(() => {
  let msg = '';
  switch (currentPage.value) {
    case 1:
      msg = props.status === 'publish' ? 'Update your intake form sections and concerns.' : 'Create and brand your intake form to be customized to your business.';
      break;
    case 2:
      msg = 'Customize the entry screen for your intake form.';
      break;
    case 31:
      msg = 'Customize colors to match your brand.';
      break;
    case 3:
      msg = props.status === 'publish' ? 'Update the confirmation message shown to patients after form submission.' : 'Setup the confirmation message shown to patients after form submission.';
      break;
    case 4:
      msg = props.status === 'publish' ? 'Update the results email sent to patients after form submission.' : 'Setup the results email sent to patients after form submission.';
      break;
  }
  return msg;
});

const form = reactive({
  content: {
    title: props.form?.content?.title,
    name: props.form?.content?.name || props.formPracticeName || '',
    content: props.form?.content?.content || 'All virtual submissions are confidential and will only be shared with your [Practice Name] Provider.',
    directions: props.form?.content?.directions || 'Select concerns from each area of the body. If you do not have a concern in an area you can skip that section.',
    link: props.form?.content?.link || props.formExitLink,
    websiteLink: props.form?.content?.websiteLink || props.formWebsiteLink,
    logoUrl: props.form?.content?.logo || props.formNavigationLogo?.url || null,
    imageUrl: props.form?.content?.image || props.formPracticeOrDoctorImage?.url || null,
    imageCaption: props.form?.content?.imageCaption || props.formImageCaption,
  },
  colors: {
    backgroundColor: props.formColors?.background_color || '#F9F9FF',
    cardShadow: props.formColors?.card_shadow || '#CCCCCC',
    checkmarkInactiveButtonColor: props.formColors?.checkmark_inactive_button_color || '#FFFFFF',
    headingTextColor: props.formColors?.heading_text_color || '#231E2E',
    dividerLineColor: props.formColors?.divider_line_color || '#CCCCCC',
    checkmarkInactiveTextColor: props.formColors?.checkmark_inactive_text_color || '#443E51',
    bodyTextColor: props.formColors?.body_text_color || '#777777',
    primaryButtonColor: props.formColors?.primary_button_color || '#5A56F9',
    checkmarkHoverButtonColor: props.formColors?.checkmark_hover_button_color || '#E6E6FE',
    navColor: props.formColors?.nav_color || '#FFFFFF',
    primaryButtonTextColor: props.formColors?.primary_button_text_color || '#FFFFFF',
    checkmarkHoverTextColor: props.formColors?.checkmark_hover_text_color || '#231E2E',
    exitLinkTextColor: props.formColors?.exit_link_text_color || '#231E2E',
    primaryButtonHoverColor: props.formColors?.primary_button_hover_color || '#443E51',
    checkmarkSelectedButtonColor: props.formColors?.checkmark_selected_button_color || '#5A56F9',
    exitLinkHoverTextColor: props.formColors?.exit_link_hover_text_color || '#5A56F9',
    primaryButtonHoverTextColor: props.formColors?.primary_button_hover_text_color || '#FFFFFF',
    checkmarkHoverTextColor: props.formColors?.checkmark_hover_text_color || '#FFFFFF',
  },
  confirmation: {
    heading: props.form?.confirmation?.heading || 'Thank You for Your Submission!',
    paragraph: props.form?.confirmation?.paragraph || 'We have successfully received your intake form submission. Our team will review the information, and help provide you solutions to any of your concerns.',
  },
  email: {
    resultsEmail: props.form?.email?.resultsEmail || '',
    introduction: props.form?.email?.introduction || 'Intake Form Results for {first_name} {last_name}.',
    message: props.form?.email?.message || '',
    navLogoUrl: props.form?.email?.navLogoUrl || null,
    backgroundColor: props.emailColors?.background_color || '#F9F9FF',
    headingTextColor: props.emailColors?.heading_text_color || '#231E2E',
    bodyTextColor: props.emailColors?.body_text_color || '#777777',
    lineDividerColor: props.emailColors?.line_divider_color || '#CCCCCC',
  }
});

const handleTriggerToNextPage = async () => {
  try {
    let res = await validateAndSavePage();
    if(res) {
      // For non-published forms, navigate between pages
      if (props.status !== 'publish') {
        if (currentPage.value === 1) {
          // From page 1 to IntakeWrapper (page 2)
          isLoading.value = true;
          window.location.href = "/intake/" + props.postHash;
        } else if (currentPage.value === 3) {
          // From page 3 (confirmation) to page 4 (email)
          window.location.href = "/intake/style/" + props.postHash + "?step=4";
        } else if (currentPage.value === 4) {
          // From page 4 back to dashboard
          window.location.href = "/dashboard";
        }
      } else {
        // For published forms, just switch tabs
        currentPage.value = currentPage.value + 1;
      }
    }
  } catch (error) {
    console.error(error);
  }
}

const handleUpdateCurrentPage = (newPage) => {
  currentPage.value = newPage;
}

onMounted(() => {
  logoPreview.value = props.form?.content?.logo || props.formNavigationLogo?.url || null;
  imagePreview.value = props.form?.content?.image || props.formPracticeOrDoctorImage?.url || null;
  navLogoPreview.value = props.form?.email?.navLogoUrl || props.formNavigationLogo?.url || null;
});

const createPreview = (file, type) => {
  const reader = new FileReader();
  reader.onload = (e) => {
    if (type === 'logo') {
      logoPreview.value = e.target.result;
      logoFile.value = file;
    } else if (type === 'image') {
      imagePreview.value = e.target.result;
      imageFile.value = file;
    } else if (type === 'navLogo') {
      navLogoPreview.value = e.target.result;
      navLogoFile.value = file;
    }
  };
  reader.readAsDataURL(file);
};

const handleNavLogoSelect = (event) => {
  const file = event.target.files[0];
  if (file) {
    createPreview(file, 'navLogo');
  }
};

const handleLogoSelect = (event) => {
  const file = event.target.files[0];
  if (file) {
    createPreview(file, 'logo');
  }
};

const handleImageSelect = (event) => {
  const file = event.target.files[0];
  if (file) {
    createPreview(file, 'image');
  }
};

const clearMedia = (type) => {
  pendingClearMediaType.value = type;
  showClearMediaConfirmationPopup.value = true;
};

const executeClearMedia = () => {
  const type = pendingClearMediaType.value;
  if (type === 'logo') {
    logoPreview.value = null;
    logoFile.value = null;
    form.content.logoUrl = null;
    if (logo.value) {
      logo.value.value = '';
    }
  } else if (type === 'image') {
    imagePreview.value = null;
    imageFile.value = null;
    form.content.imageUrl = null;
    if (image.value) {
      image.value.value = '';
    }
  } else if (type === 'navLogo') {
    navLogoPreview.value = null;
    navLogoFile.value = null;
    form.content.navLogoUrl = null;
    if (navLogo.value) {
      navLogo.value.value = '';
    }
  }
  closePopup();
};

const toNextPage = async () => {
  const isValid = await validateAndSavePage();
  if (isValid) {
    window.location.href = "/intake/" + props.postHash;
  }
}

const toDashboard = async () => {
  const isSubmit = await validateAndSavePage();
  if (isSubmit) {
    window.location.href = "/";
  }
}

const publishIntakeForm = async () => {
  if(currentPage.value === 1) {
    await handleSaveSection();
  } else {
    const isSubmit = await validateAndSavePage();
    if (isSubmit) {
      try {
        const { data } = await axios.post(
          `${siteInfo.wpApiSettings.ll}intake/publish`,
          {
            postId: props.postId,
          },
          {
            headers: {
              'X-WP-Nonce': siteInfo.wpApiSettings.nonce,
              'X-Requested-With': 'XMLHttpRequest'
            },
          }
        );
        if(props.status !== 'publish') {
          window.location.href = "/";
        } else {
          isLoading.value = false;
        }
      } catch (error) {
        console.error('Error publishing intake form:', error);
        isLoading.value = false;
        return false;
      }
    } else {
      isLoading.value = false;
    }
  }
}

const uploadToMediaLibrary = async (file) => {
  if (!file) {
    return null;
  }

  const formData = new FormData();
  formData.append('file', file);
  formData.append('post', props.postId);
  formData.append('title', file.name);
  formData.append('alt_text', 'Uploaded image');

  try {
    const response = await axios.post(
      `${siteInfo.wpApiSettings.root}wp/v2/media`,
      formData,
      {
        headers: {
          'X-WP-Nonce': siteInfo.wpApiSettings.nonce,
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return {
      id: response.data.id,
      url: response.data.source_url
    };
  } catch (error) {
    console.error('Upload failed:', error);
    return null;
  }
};

const validateForm = () => {
  let isValid = true;
  if (!form.content.title) {
    errorTitle.value = true;
    errorMessage.value = true;
    isValid = false;
  }
  if (!form.content.name) {
    errorPractice.value = true;
    errorMessage.value = true;
    isValid = false;
  }
  if (!form.content.content) {
    errorContent.value = true;
    errorMessage.value = true;
    isValid = false;
  }
  if (!form.content.directions) {
    errorDirections.value = true;
    errorMessage.value = true;
    isValid = false;
  }
  if (!form.confirmation.heading) {
    errorConfirmationHeading.value = true;
    errorMessage.value = true;
    isValid = false;
  }
  if (!form.email.resultsEmail) {
    errorEmail.value = true;
    errorMessage.value = true;
    isValid = false;
  }
  if (!form.email.introduction) {
    errorEmailSubject.value = true;
    errorMessage.value = true;
    isValid = false;
  }
  if (!form.email.message) {
    errorEmailMessage.value = true;
    errorMessage.value = true;
    isValid = false;
  }

  return isValid;
}

const validatePage = () => {
  let isValid = true;
  switch(currentPage.value) {
    case 1:
      errorMessage.value = false;
      isValid = true;
    case 2:
      if (!form.content.title) {
        errorTitle.value = true;
        errorMessage.value = true;
        isValid = false;
      }
      if (!form.content.name) {
        errorPractice.value = true;
        errorMessage.value = true;
        isValid = false;
      }
      if (!form.content.content) {
        errorContent.value = true;
        errorMessage.value = true;
        isValid = false;
      }
      if (!form.content.directions) {
        errorDirections.value = true;
        errorMessage.value = true;
        isValid = false;
      }
      break;
    case 31:
      break;
    case 3:
      if (!form.confirmation.heading) {
        errorConfirmationHeading.value = true;
        errorMessage.value = true;
        isValid = false;
      }
      if (!form.confirmation.paragraph) {
        errorConfirmationParagraph.value = true;
        errorMessage.value = true;
        isValid = false;
      }
      break;
    case 4:
      if (!form.email.resultsEmail) {
        errorEmail.value = true;
        errorMessage.value = true;
        isValid = false;
      }
      if (!form.email.introduction) {
        errorEmailSubject.value = true;
        errorMessage.value = true;
        isValid = false;
      }
      if (!form.email.message) {
        errorEmailMessage.value = true;
        errorMessage.value = true;
        isValid = false;
      }
      break;
    default:
      errorTitle.value = false;
      errorPractice.value = false;
      errorContent.value = false;
      errorDirections.value = false;
      errorConfirmationHeading.value = false;
      errorConfirmationParagraph.value = false;
      errorEmail.value = false;
      errorEmailSubject.value = false;
      errorEmailMessage.value = false;
      errorMessage.value = false;
      break;
  }
  if(isValid) {
    errorTitle.value = false;
    errorPractice.value = false;
    errorContent.value = false;
    errorDirections.value = false;
    errorConfirmationHeading.value = false;
    errorConfirmationParagraph.value = false;
    errorEmail.value = false;
    errorEmailSubject.value = false;
    errorEmailMessage.value = false;
    errorMessage.value = false;
  }
  return isValid;
}

const validateAndSavePage = async (e) => {
  let response = null;
  if (!isRunning.value && validatePage()) {
    try {
      isLoading.value = true;
      isRunning.value = true;

      let logoData = null;
      let imageData = null;
      let navLogoData = null;

      if (logoFile.value) {
        try {
          const validatedLogo = await validateAndResizeImage(logoFile.value);
          if (validatedLogo) {
            const logoBlob = await fetch(validatedLogo).then(r => r.blob());
            const validatedLogoFile = new File([logoBlob], logoFile.value.name, { type: logoFile.value.type });
            logoData = await uploadToMediaLibrary(validatedLogoFile);
            if (logoData) {
              form.content.logoUrl = logoData.url;
            }
          }
        } catch (error) {
          console.error('Logo validation failed:', error);
        }
      }

      if (imageFile.value) {
        try {
          const validatedImage = await validateAndResizeImage(imageFile.value);
          if (validatedImage) {
            const imageBlob = await fetch(validatedImage).then(r => r.blob());
            const validatedImageFile = new File([imageBlob], imageFile.value.name, { type: imageFile.value.type });
            imageData = await uploadToMediaLibrary(validatedImageFile);
            if (imageData) {
              form.content.imageUrl = imageData.url;
            }
          }
        } catch (error) {
          console.error('Image validation failed:', error);
        }
      }

      if (navLogoFile.value) {
        try {
          const validatedNavLogo = await validateAndResizeImage(navLogoFile.value);
          if (validatedNavLogo) {
            const navLogoBlob = await fetch(validatedNavLogo).then(r => r.blob());
            const validatedNavLogoFile = new File([navLogoBlob], navLogoFile.value.name, { type: navLogoFile.value.type });
            navLogoData = await uploadToMediaLibrary(validatedNavLogoFile);
            if (navLogoData) {
              form.email.navLogoUrl = navLogoData.url;
            }
          }
        } catch (error) {
          console.error('Navigation Logo validation failed:', error);
        }
      }

      response = await axios({
        method: 'POST',
        url: `${siteInfo.wpApiSettings.ll}intake-styles/submit`,
        headers: {
          'X-WP-Nonce': siteInfo.wpApiSettings.nonce,
          'X-Requested-With': 'XMLHttpRequest'
        },
        data: {
          postId: props.postId,
          form: {
            ...form,
            content: {
              ...form.content,
              logo: logoData?.url || form.content.logoUrl,
              image: imageData?.url || form.content.imageUrl,
              navLogo: navLogoData?.url || form.email.navLogoUrl,
            }
          },
        },
      });

      if (logoData) {
        logoPreview.value = logoData.url;
        logoFile.value = null;
      }
      if (imageData) {
        imagePreview.value = imageData.url;
        imageFile.value = null;
      }
      if (navLogoData) {
        navLogoPreview.value = navLogoData.url;
        navLogoFile.value = null;
      }

    } catch (error) {
      console.error('Error:', error);
    } finally {
      isRunning.value = false;
    }
  }

  return response;
};

const validateAndResizeImage = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function (e) {
      const img = new Image();
      img.onload = function () {
        const width = img.naturalWidth;
        const height = img.naturalHeight;

        if (width > 1999 || height > 1999) {
          validationMessage.value = 'Image dimensions exceed maximum allowed width (1999px) or height (1999px). Resizing the image...';

          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          let newWidth, newHeight;
          if (width > height) {
            newWidth = 1999;
            newHeight = (height / width) * 1999;
          } else {
            newHeight = 1999;
            newWidth = (width / height) * 1999;
          }

          canvas.width = newWidth;
          canvas.height = newHeight;

          ctx.drawImage(img, 0, 0, newWidth, newHeight);
          const resizedImage = canvas.toDataURL('image/jpeg');
          validationMessage.value = null;
          resolve(resizedImage);
        } else {
          validationMessage.value = null;
          resolve(e.target.result);
        }
      };
      img.onerror = function () {
        validationMessage.value = 'Invalid image file. Please choose a valid image.';
        resolve(false);
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });
}

const handleEditSectionDetail = async (section) => {
  reactiveSections[section.index].name = section.name;
  reactiveSections[section.index].direction = section.direction;
}

const submitSectionDetail = async (section) => {
  showSectionDetailIndex.value = null;
  showSectionDetailEdit.value = false;
  sectionDetailActive.value = 'hidden';
  // await handleSaveSection();
}

watch(
  () => reactiveSections.map(section => section.concerns),
  async () => {
    await handleSaveSection();
  },
  { deep: true }
);

const handleSaveSection = async () => {
  isSaving.value = true; // Set saving state to true
  saveStatus.value = ''; // Reset save status message
  isLoading.value = true;
  saveText.value = 'Saving...';

  try {
    const response = await axios({
      method: 'POST',
      url: `${siteInfo.wpApiSettings.ll}intakes/save-section`,
      headers: {
        'X-WP-Nonce': siteInfo.wpApiSettings.nonce,
        'X-Requested-With': 'XMLHttpRequest'
      },
      data: {
        userId: props.userId,
        postId: props.postId,
        sections: reactiveSections,
      }
    });

    // Check response status and set success message
    if (response.status === 200) {
      saveStatus.value = 'Sections saved successfully!';
      saveText.value = 'Saved';
      setTimeout(() => {
        saveText.value = 'Update';
      }, 1500);
    }
  } catch (error) {
    console.error('Error updating user intro status:', error);
    saveText.value = 'Error, try again';
    saveStatus.value = 'Error saving sections. Please try again.';
    setTimeout(() => {
      saveText.value = 'Update';
    }, 2000);
  } finally {
    $.magnificPopup.close();
    isLoading.value = false;
    isSaving.value = false; // Reset saving state
  }
};
</script>

<style scoped>
.tab-fade-enter-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.tab-fade-leave-active {
  transition: opacity 0.15s ease;
}
.tab-fade-enter-from {
  opacity: 0;
  transform: translateY(8px);
}
.tab-fade-leave-to {
  opacity: 0;
}
</style>
